export default ({ qrCodeTitle, qrCodeUrl, qrCodeFileName, link }) => `
<html>
  <head>
    <title>${qrCodeTitle}</title>
    <style>
      body {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100vh;
        margin: 0;
      }
      img {
        max-width: 100%;
        height: auto;
      }
      button {
        padding: 4px 10px;
        background: hsl(117, 49%, 37%);
        color: white;
        border: 1px solid hsl(117, 49%, 37%);
        transition: .5s;
        border-radius: 4px;
        text-transform: uppercase;
        letter-spacing: .05em;
        font-family: 'Barlow Elotech', Helvetica, Arial, sans-serif;
        font-weight: 500;
        cursor: pointer;
      }
      button:hover {
        background: hsl(117, 49%, 27%);
      }
      @media print {
        .buttons {
          display: none;
        }
      }
    </style>
  </head>
  <body>
    <img src="${qrCodeUrl}" alt="${qrCodeTitle}" />
    <div class="buttons">
      ${
        link
          ? `
            <button onclick="window.open('${link}', '_blank')">Abrir Link</button>
            <button onclick="copiar('${link}')">Copiar</button>
          `
          : ''
      }
      <button onclick="window.print()">Imprimir</button>
      <button onclick="saveImage()">Salvar</button>
    </div>
    <script>
      function saveImage() {
        const link = document.createElement('a');
        link.href = '${qrCodeUrl}';
        link.download = '${qrCodeFileName}.png';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      function copiar(text) {
        if (!navigator.clipboard) {
          alert('API de Clipboard não suportada neste navegador. Copie o link manualmente: ' + text);
          return;
        }
        navigator.clipboard.writeText(text).then(() => {
          alert('Link copiado para a área de transferência!');
        }).catch(err => {
          alert('Falha ao copiar o link: ' + err);
        });
      }
    </script>
  </body>
</html>`;
